export default __webpack_public_path__ + "static/media/departed-by-road.5b9f391c.svg";